/** @format */
import _ from 'lodash';
import { CommonCodeService } from '../service/common-code.service';
import priorLearningApplicationSummaryTpl from './priorLearningApplicationSummary.tpl.html';
import { textWithDefaultMissingValueModule } from './textWithDefaultMissingValue.component';

export const priorLearningApplicationSummaryModule = 'sis-components.applications.priorLearningApplicationSummary';

(function () {
    /**
     * Use Angular component PriorLearningWorkflowSummary instead in future development.
     *
     * @deprecated
     */
    angular
        .module(priorLearningApplicationSummaryModule, [
            textWithDefaultMissingValueModule,
            'sis-components.model.language',
            'sis-components.model.preferredLanguage',
            'sis-components.service.courseUnitService',
            'sis-components.service.curriculumPeriodService',
            'sis-components.service.moduleService',
            'sis-components.service.studyRightService',
            'sis-components.model.studentApplication',
            CommonCodeService.downgrade.moduleName,
        ])
        .component('priorLearningApplicationSummary', {
            template: priorLearningApplicationSummaryTpl,
            bindings: {
                application: '<',
                openCourseUnitInfoModalCallback: '&?',
                showLinksForStaff: '<',
            },
            controller: [
                '$scope',
                '$q',
                'commonCourseUnitService',
                'commonCurriculumPeriodService',
                'commonModuleService',
                'commonStudyRightService',
                'preferredLanguageJSDataModel',
                'STUDENT_APPLICATION_TYPE',
                'commonCodeService',
                function (
                    $scope,
                    $q,
                    commonCourseUnitService,
                    commonCurriculumPeriodService, // NOSONAR
                    commonModuleService,
                    commonStudyRightService,
                    preferredLanguageJSDataModel,
                    STUDENT_APPLICATION_TYPE,
                    commonCodeService,
                ) {
                    $scope.STUDENT_APPLICATION_TYPE = STUDENT_APPLICATION_TYPE;

                    const ctrl = this;

                    ctrl.$onInit = function () {
                        preferredLanguageJSDataModel.lazyGetAll().then(function (languages) {
                            ctrl.preferredLanguages = languages;
                        });
                        if (ctrl.showLinksForStaff) {
                            ctrl.studentLink = getStudentLink();
                            ctrl.studyPlanLink = getStudyPlanLink();
                        }
                        return $q.all([
                            resolveEducation(ctrl.application),
                            resolveCourseUnitVersionName(ctrl.application),
                            resolvePlannedParentModule(ctrl.application),
                        ]);
                    };

                    ctrl.getLanguageName = function (languageUrn) {
                        return _.get(_.find(ctrl.preferredLanguages, { urn: languageUrn }), 'name');
                    };

                    ctrl.openCourseUnitInfoModal = function () {
                        if (ctrl.openCourseUnitInfoModalCallback) {
                            ctrl.openCourseUnitInfoModalCallback();
                        }
                    };

                    function resolveEducation(application) {
                        return commonStudyRightService.findById(application.studyRightId, false, true).then(studyRight => {
                            ctrl.educationPhase1GroupId = studyRight.acceptedSelectionPath?.educationPhase1GroupId;
                            ctrl.educationPhase2GroupId = studyRight.acceptedSelectionPath?.educationPhase2GroupId;
                            ctrl.educationPhase1ChildGroupId = studyRight.acceptedSelectionPath?.educationPhase1ChildGroupId;
                            ctrl.educationPhase2ChildGroupId = studyRight.acceptedSelectionPath?.educationPhase2ChildGroupId;
                            ctrl.phase1GraduationDate = studyRight.studyRightGraduation?.phase1GraduationDate;
                            ctrl.education = studyRight.education;
                            resolveChildModuleName();
                            resolveChildNaming();
                            resolveActivePhase();
                        });
                    }

                    function resolveChildModuleName() {
                        ctrl.childGroupId = ctrl.phase1GraduationDate ? ctrl.educationPhase2ChildGroupId : ctrl.educationPhase1ChildGroupId;
                        commonModuleService.findByGroupIds([ctrl.childGroupId]).then(mod => {
                            ctrl.childModule = mod.length !== 0 ? mod[0] : null;
                        });
                    }

                    function resolveChildNaming() {
                        ctrl.options = ctrl.phase1GraduationDate
                            ? ctrl.education.structure?.phase2?.options
                            : ctrl.education.structure?.phase1?.options;
                        ctrl.option = _.find(ctrl.options, opt => _.some(opt.childOptions, { moduleGroupId: ctrl.childGroupId }));
                        commonCodeService.getCode(ctrl.option?.childNaming).then(code => {
                            ctrl.childNamingCode = code;
                        });
                    }

                    function resolveActivePhase() {
                        ctrl.activePhaseId = ctrl.phase1GraduationDate ? ctrl.educationPhase2GroupId : ctrl.educationPhase1GroupId;
                        commonModuleService.findByGroupIds([ctrl.activePhaseId]).then(mod => {
                            ctrl.activePhase = mod.length !== 0 ? mod[0] : null;
                        });
                    }

                    function resolveCourseUnitVersionName(application) {
                        if (!application.courseUnit) {
                            return $q.when();
                        }

                        return commonCurriculumPeriodService
                            .findCurriculumPeriodsByIds(application.courseUnit.curriculumPeriodIds)
                            .then(function (curriculumPeriods) {
                                return commonCourseUnitService.getDisplayName(curriculumPeriods);
                            })
                            .then(function (displayName) {
                                ctrl.courseUnitVersionName = displayName;
                            });
                    }

                    function resolvePlannedParentModule(application) {
                        if (!application.plannedParentModuleId) {
                            return $q.when();
                        }

                        commonModuleService.findById(application.plannedParentModuleId).then(function (module) {
                            ctrl.plannedParentModule = module;
                        });
                    }

                    function getStudentLink() {
                        if (!ctrl.application.student) {
                            return null;
                        }
                        const studentId = ctrl.application.student.id;
                        return `/tutor/role/staff/student/${studentId}/basic/basic-info`;
                    }

                    function getStudyPlanLink() {
                        if (!ctrl.application.student || !ctrl.application.planId) {
                            return null;
                        }
                        const studentId = ctrl.application.student.id;
                        const studyPlanId = ctrl.application.planId;
                        return `/tutor/role/staff/student/${studentId}/tutoring/plan/${studyPlanId}/structure`;
                    }
                },
            ],
        });
})();
